import {Component, Input, OnInit} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {AppComponent} from '../../app.component';
import {ExgModalService} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ExcDatePipe, ExcRestService} from 'exc-rest-v2';
import {EnumerationService} from '../../services/enumeration.service';


@Component({
  selector: 'app-modal-detail-history',
  templateUrl: './modal-detail-history.component.html',
  styles: [],
  providers: [ExcDatePipe]
})
export class ModalDetailHistoryComponent extends ExcTranslation implements OnInit {
  @Input()
  data: any;

  allKeys = ['LCD', 'LCU', 'CKD', 'CKU', 'CRD', 'CRU', 'DEL', 'DLD', 'DLU', 'LCK', 'LKD', 'LKU', 'VFR', 'VTO'];

  historyTable = {
    isLoading: true,
    state: 1,
    historyDate: [] as any[],
    history: [] as any[],
    OEs: {} as any,
    ready: () => {
      if (this.historyTable.history.length === 0) {
        this.historyTable.state = 2;
      } else {
        this.historyTable.state = 0;
      }
    },
    loadData: () => {
      const SELF = this;
      SELF.historyTable.state = 1;
      SELF.historyTable.isLoading = true;
      SELF.excRest
        .get(
          SELF.excRest.computeUrl('HistoryR_List', {
            fkID: SELF.data.ID
          }), {}
        )
        .subscribe((response) => {
          if (response.success && response.data) {
            if (response.data.OEs !== undefined && response.data.OEs !== null) {
              for (let counter = 0; counter < response.data.OEs.length; counter++) {
                SELF.historyTable.OEs[response.data.OEs[counter].oeID.toLowerCase()] = response.data.OEs[counter];
              }
            }
            SELF.historyTable.loadObjects(response.data.History, response.data.HistoryDate);
          } else {
            SELF.historyTable.history = [];
            SELF.historyTable.historyDate = [];
          }
          SELF.historyTable.isLoading = false;
          SELF.historyTable.ready();
        });
    },
    loadObjects: (history: any, historyDate: any): void => {
      for (const historyElement of history) {
        if (historyElement.histNewValues) {
          Object.assign(
            historyElement,
            {
              newValues: JSON.parse(historyElement.histNewValues),
              newValuesKeys: []
            });
          for (const newValue of historyElement.newValues) {
            if (!historyElement.newValuesKeys.includes(newValue.key)) {
              historyElement.newValuesKeys.push(newValue.key);
            }
          }
        }
        if (historyElement.histOldValues) {
          Object.assign(
            historyElement,
            {
              oldValues: JSON.parse(historyElement.histOldValues),
              oldValuesKeys: []
            });
          for (const oldValue of historyElement.oldValues) {
            if (!historyElement.oldValuesKeys.includes(oldValue.key)) {
              historyElement.oldValuesKeys.push(oldValue.key);
            }
          }
        }
        Object.assign(historyElement, {histValues: []});
        if (historyElement.newValues.length > 0) {
          for (const newValue of historyElement.newValues) {
            if (!(newValue.key.includes('UPT')
              || newValue.key.includes('Cache')
              || newValue.key.includes('FristDiff'))
            ) {
              if (historyElement.oldValuesKeys
                && historyElement.oldValuesKeys.length > 0
                && historyElement.oldValuesKeys.includes(newValue.key)) {
                const oldValue = historyElement.oldValues.find((oVal: any) => oVal.key === newValue.key);
                historyElement.histValues.push({
                  key: newValue.key,
                  oldValue: this.tryParse(oldValue.value, newValue.key),
                  newValue: this.tryParse(newValue.value, newValue.key),
                  histType: 0 // Changed
                });
              } else {
                historyElement.histValues.push({
                  key: newValue.key,
                  oldValue: undefined,
                  newValue: this.tryParse(newValue.value, newValue.key),
                  histType: 1 // Added
                });
              }
            }
          }
        }
        if (historyElement.oldValues
          && historyElement.oldValues.length > 0
        ) {
          for (const oldValue of historyElement.oldValues) {
            if (!(
              oldValue.key.includes('UPT')
              || oldValue.key.includes('Cache')
              || oldValue.key.includes('FristDiff'))
            ) {
              if (!historyElement.newValuesKeys.includes(oldValue.key)) {
                historyElement.histValues.push({
                  key: oldValue.key,
                  oldValue: this.tryParse(oldValue.value, oldValue.key),
                  newValue: undefined,
                  histType: 2 // Deleted
                });
              }
            }
          }
        }
        if (historyElement.histValues.length > 0) {
          this.historyTable.history.push(historyElement);
        }
      }
      // console.log(this.historyTable.history);
      for (const dateElement of historyDate) {
        for (const historyElement of this.historyTable.history) {
          if (
            historyElement.histTimestamp_Date === dateElement.histTimestamp_Date
            && !this.historyTable.historyDate.includes(dateElement)
          ) {

            this.historyTable.historyDate.push(dateElement);
          }
        }
      }
    }
  };
  tryParse = (value: any, fieldname: string): string | null => {
    if (fieldname.toLowerCase().indexOf('oeid') > -1 || fieldname.toLowerCase().indexOf('oid') > -1) {
      if (value === '00000000-0000-0000-0000-000000000000' || value === null || value === undefined) {
        return `<leer>`;
      } else {
        return this.historyTable.OEs[value.toLowerCase()].oeName + ', ' + this.historyTable.OEs[value.toLowerCase()].oeEName;
      }
    } else if (fieldname.toLowerCase().indexOf('enmident') > -1 && this.data.Object !== undefined) {
      return this.enmSrv.getEnumerationText(this.data.Object[fieldname.replace('enmIdent', 'enmName')], value, true);
    }
   else {
      var regEx = /^\d{4}-\d{2}-\d{2}T\d{1,2}:\d{2}:[\d.]*$/;
      if(!value.match(regEx)) return value;
      const d = new Date(value);
      if (d.toString() !== 'Invalid Date') {
        return this.datePipe.transform(d, this.getGlobal('DateTimeFormatLong'));
      }
      return value;
    }
  };

  constructor(
    public enmSrv: EnumerationService,
    public appData: AppComponent,
    public ModalService: ExgModalService,
    public excSecurity: ExcSecurityService,
    public excRest: ExcRestService,
    private datePipe: ExcDatePipe
  ) {
    super();
  }

  getDateCompare(date: any): string {
    const dt = new Date(date);
    return dt.getFullYear() + '' + (dt.getMonth() + 1) + '' + dt.getDate();
  }

  filteredDataList = (date: { histTimestamp_Date: Date }): any[] => {
    return ExcCoreModule.Array.GetAll(
      this.historyTable.history,
      'histTimestamp_Date',
      date.histTimestamp_Date);
  };

  ngOnInit(): void {
    this.initialize();
  }

  initialize(): void {
    this.historyTable.loadData();
  }

  close(): void {
    this.ModalService.close();
  }

  getKeyCaption(histObjectType: string, key: string): string {
    if (key === 'vorgFristDifference') {
      return this.enmSrv.getFieldCaption(histObjectType, 'vorgFristDiff');
    }
    for (const allKey of this.allKeys) {
      if (key.includes(allKey)) {
        return this.enmSrv.getFieldCaption('All', '%' + allKey);
      }
    }
    return this.enmSrv.getFieldCaption(histObjectType, key);
  }
}
